import React from 'react';
import PropTypes from 'prop-types';
import * as styles from './shadow-frame.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ShadowFrame = _ref => {
  var children = _ref.children;
  return ___EmotionJSX("div", {
    css: styles.frame
  }, children);
};
ShadowFrame.propTypes = {
  children: PropTypes.node.isRequired
};
export default ShadowFrame;